import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const assetsObjectRoute: InvariantJiraRoute = {
	name: 'assets-object',
	path: '/jira/assets/object/:objectId',
};
